<div class="modal-overlay" *ngIf="show">
  <div class="modal-content">
    <div class="modal-header">
      <div class="header-main">
        <div class="header-icon-container">
          <fa-icon [icon]="faRocket"></fa-icon>
        </div>
        <div class="header-titles">
          <h3>{{ 'MODELS.DEPLOY.TITLE' | translate }}</h3>
          <p>{{ model?.name }}</p>
        </div>
      </div>
      <button class="close-btn" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="modal-body">
      <div class="options-grid">
        <div class="options-section">
          <div class="section-header">
            <span class="section-title">{{ 'MODELS.DEPLOY.SECTIONS.AI_CONFIG' | translate }}</span>
          </div>

          <div class="config-fields-group">
            <div class="config-field">
              <label>{{ 'MODELS.DEPLOY.LLM_MODEL' | translate }}</label>
              <ng-select
                [items]="llmModelOptions"
                bindLabel="display_label"
                bindValue="key"
                [(ngModel)]="deployRequest.llmModel"
                [clearable]="false"
                [searchable]="true"
                appendTo="body"
                [placeholder]="'MODELS.DEPLOY.LLM_MODEL' | translate">
              </ng-select>
            </div>

            <div class="config-field">
              <label>{{ 'MODELS.DEPLOY.LANGUAGE' | translate }}</label>
              <select class="form-select" [(ngModel)]="deployRequest.language">
                <option value="pt">Português</option>
                <option value="en">English</option>
                <option value="es">Español</option>
              </select>
            </div>
          </div>

          <div class="config-fields-group">
            <div class="config-field">
              <label>{{ 'MODELS.DEPLOY.DEFAULT_VALUE' | translate }}</label>
              <select class="form-select" [(ngModel)]="defaultValueMode" (ngModelChange)="onDefaultValueModeChange()">
                <option value="default">{{ 'MODELS.DEPLOY.DEFAULT_VALUE_MODE.DEFAULT' | translate }}</option>
                <option value="empty">{{ 'MODELS.DEPLOY.DEFAULT_VALUE_MODE.EMPTY' | translate }}</option>
                <option value="custom">{{ 'MODELS.DEPLOY.DEFAULT_VALUE_MODE.CUSTOM' | translate }}</option>
              </select>
              @if (defaultValueMode === 'custom') {
              <input type="text" class="form-input" [(ngModel)]="deployRequest.extractionDefaultValue"
                [placeholder]="'MODELS.DEPLOY.DEFAULT_VALUE_PLACEHOLDER' | translate">
              }
            </div>

            <div class="config-field">
              <label>{{ 'MODELS.DEPLOY.DEFAULT_PROBABILITY' | translate }}</label>
              <input type="number" class="form-input" [(ngModel)]="deployRequest.extractionDefaultProbability"
                step="0.1" min="0" max="1">
            </div>
          </div>
        </div>

        <div class="options-section">
          <div class="section-header">
            <span class="section-title">{{ 'MODELS.DEPLOY.SECTIONS.OCR_CONFIG' | translate }}</span>
          </div>

          <div class="config-fields-group">
            <div class="config-field">
              <label>{{ 'MODELS.DEPLOY.OCR_TYPE' | translate }}</label>
              <select class="form-select" [(ngModel)]="deployRequest.ocrType">
                <option value="azure">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.AZURE' | translate }} (azure)</option>
                <option value="azure4">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.AZURE4' | translate }} (azure4)</option>
                <option value="google">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.GOOGLE' | translate }} (google)</option>
                <option value="paddle">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.PADDLE' | translate }} (paddle)</option>
                <option value="docling">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.DOCLING' | translate }} (docling)</option>
              </select>
            </div>

            <div class="config-field">
              <label>{{ 'MODELS.DEPLOY.TEXT_TYPE' | translate }}</label>
              <select class="form-select" [(ngModel)]="deployRequest.textType">
                <option value="print">{{ 'CONFIGURATIONS.FORM.OPTIONS.TEXT_TYPE.PRINT' | translate }} (print)</option>
                <option value="hand">{{ 'CONFIGURATIONS.FORM.OPTIONS.TEXT_TYPE.HAND' | translate }} (hand)</option>
                <option value="mix">{{ 'CONFIGURATIONS.FORM.OPTIONS.TEXT_TYPE.MIX' | translate }} (mix)</option>
              </select>
            </div>
          </div>

          <div class="config-fields-group">
            <div class="config-field">
              <label>{{ 'MODELS.DEPLOY.ADJUST_ROTATION' | translate }}</label>
              <select class="form-select" [(ngModel)]="deployRequest.adjustRotation">
                <option value="">{{ 'CONFIGURATIONS.FORM.OPTIONS.ADJUST_ROTATION.NONE' | translate }}</option>
                <option value="1">{{ 'CONFIGURATIONS.FORM.OPTIONS.ADJUST_ROTATION.PADDLE' | translate }} (1)</option>
                <option value="2">{{ 'CONFIGURATIONS.FORM.OPTIONS.ADJUST_ROTATION.REDO_OCR' | translate }} (2)</option>
              </select>
            </div>

            <div class="config-field">
              <label>{{ 'MODELS.DEPLOY.LAYOUT_ANALYSIS' | translate }}</label>
              <select class="form-select" [(ngModel)]="deployRequest.layoutAnalysis">
                <option value="">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.NONE' | translate }}</option>
                <option value="true">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.AZURE_DOCUMENT' | translate }} (true)</option>
                <option value="1">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.TABLE_TRANSFORMER' | translate }} (1)</option>
                <option value="2">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.TABLE_STRUCTURE' | translate }} (2)</option>
                <option value="3">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.OMR_V31' | translate }} (3)</option>
                <option value="4">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.OMR_V32' | translate }} (4)</option>
              </select>
            </div>
          </div>

          <div class="cache-toggle-grid">
            <div class="checkbox-item" [class.active]="deployRequest.ocrCrop"
              (click)="deployRequest.ocrCrop = !deployRequest.ocrCrop">
              <div class="checkbox-control">
                <fa-icon [icon]="deployRequest.ocrCrop ? faToggleOn : faToggleOff"></fa-icon>
              </div>
              <span class="checkbox-label">{{ 'MODELS.DEPLOY.OCR_CROP' | translate }}</span>
            </div>

            <div class="checkbox-item" [class.active]="deployRequest.ocrSort"
              (click)="deployRequest.ocrSort = !deployRequest.ocrSort">
              <div class="checkbox-control">
                <fa-icon [icon]="deployRequest.ocrSort ? faToggleOn : faToggleOff"></fa-icon>
              </div>
              <span class="checkbox-label">{{ 'MODELS.DEPLOY.OCR_SORT' | translate }}</span>
            </div>

            <div class="checkbox-item" [class.active]="deployRequest.autoCut"
              (click)="deployRequest.autoCut = !deployRequest.autoCut">
              <div class="checkbox-control">
                <fa-icon [icon]="deployRequest.autoCut ? faToggleOn : faToggleOff"></fa-icon>
              </div>
              <span class="checkbox-label">{{ 'MODELS.DEPLOY.AUTO_CUT' | translate }}</span>
            </div>

            <div class="checkbox-item" [class.active]="deployRequest.enhanceDocument"
              (click)="deployRequest.enhanceDocument = !deployRequest.enhanceDocument">
              <div class="checkbox-control">
                <fa-icon [icon]="deployRequest.enhanceDocument ? faToggleOn : faToggleOff"></fa-icon>
              </div>
              <span class="checkbox-label">{{ 'MODELS.DEPLOY.ENHANCE_DOCUMENT' | translate }}</span>
            </div>

            <div class="checkbox-item" [class.active]="deployRequest.splitPdf"
              (click)="deployRequest.splitPdf = !deployRequest.splitPdf">
              <div class="checkbox-control">
                <fa-icon [icon]="deployRequest.splitPdf ? faToggleOn : faToggleOff"></fa-icon>
              </div>
              <span class="checkbox-label">{{ 'MODELS.DEPLOY.SPLIT_PDF' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <app-button [text]="'BUTTON.CANCEL' | translate" variant="secondary" (clicked)="onClose()">
      </app-button>
      <app-button [text]="'BUTTON.DEPLOY' | translate" variant="primary" [icon]="faRocket" [loading]="loading"
        (clicked)="onDeploy()">
      </app-button>
    </div>
  </div>
</div>